import React from "react";
import Header from "./Header";
import "./Hero.css";
import hero_image from "../assets/hero_image.png";
import hero_image_back from "../assets/hero_image_back.png";
import heart from "../assets/heart.png";
import calories from "../assets/calories.png";
import { motion } from "framer-motion";
import NumberCounter from "number-counter";
export default function Hero() {
  const transition = { type: "spring", duration: 3 };
  const mobile = window.innerWidth <= 768 ? true : false;
  return (
    <>
      <div className="hero" id="home">
        <div className="blur blur-h"></div>
        <div className="left-h">
          <Header />
          <div className="the-best-ad">
            <motion.div
              initial={{ left: mobile ? "165px" : "238px" }}
              whileInView={{ left: "8px" }}
              transition={{ ...transition, type: "tween" }}
            ></motion.div>
            <span>The Best Fitness Club in the Town</span>
          </div>

          {/*Hero Heading*/}
          <div className="hero-text">
            <div>
              <span className="stroke-text">Shape</span>
              <span> Your</span>
            </div>
            <div>
              <span>Ideal Body</span>
            </div>
            <div>
              <span>
                In here we will help you to shape and build your ideal body and
                live up your life to fullest
              </span>
            </div>
          </div>

          {/*Hero Figures*/}
          <div className="figures">
            <div>
              <span>
                <NumberCounter end={164} start={110} delay="3" preFix="+" />
              </span>
              <span>Expert Coaches</span>
            </div>
            <div>
              <span>
                <NumberCounter end={823} start={704} delay="4" preFix="+" />
              </span>
              <span>Members Joined</span>
            </div>
            <div>
              <span>
                <NumberCounter end={40} start={10} delay="2" preFix="+" />
              </span>
              <span>Fitness Programs</span>
            </div>
          </div>

          {/*Hero Buttons*/}
          <div className="hero-buttons">
            <buttons className="btn btn1">Get Started</buttons>
            <buttons className="btn btn2">Learn More</buttons>
          </div>
        </div>

        <div className="right-h">
          <button className="btn btn-join">Join Now</button>
          <motion.div
            initial={{ right: "-1rem" }}
            whileInView={{ right: "4rem" }}
            transition={transition}
            className="heart-rate"
          >
            <img src={heart} alt="heart_img" />
            <span>Heart Rate</span>
            <span>116 bpm</span>
          </motion.div>

          {/*Hero Images section*/}
          <img className="hero-image" src={hero_image} alt="hero_img" />
          <motion.img
            initial={{ right: "11rem" }}
            whileInView={{ right: "20rem" }}
            transition={transition}
            className="hero-image-back"
            src={hero_image_back}
            alt="hero_img_back"
          />
          {/*Calories*/}
          <motion.div
            initial={{ right: "37rem" }}
            whileInView={{ right: "28rem" }}
            transition={transition}
            className="calories"
          >
            <img src={calories} alt="calories" />
            <div>
              <span>Calories Burned</span>
              <span>220 Kcal</span>
            </div>
          </motion.div>
        </div>
      </div>
    </>
  );
}
